import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "@phosphor-icons/react";
import { COMPANY, NAV_LINKS, SERVICES } from "@/lib/content";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-bone grain">
    <div className="max-w-[1440px] mx-auto px-5 md:px-10 pt-20 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-bone/15">
        <div className="md:col-span-5">
          <p className="font-cabinet text-3xl md:text-4xl font-bold tracking-tight text-balance">
            Har jeres virksomhed brug for en maler eller underentreprenør?
          </p>
          <p className="mt-4 text-bone/60 text-sm max-w-md">
            Kontakt os for en uforpligtende dialog om opgaven – vi svarer hurtigt og konkret.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/kontakt"
              data-testid="footer-quote-button"
              className="flex items-center gap-2 bg-signal text-bone text-sm font-semibold px-6 py-3 hover:bg-bone hover:text-ink transition-colors duration-300"
            >
              Indhent tilbud <ArrowUpRight size={16} weight="bold" />
            </Link>
            <a
              href={COMPANY.phoneHref}
              data-testid="footer-call-button"
              className="flex items-center gap-2 border border-bone/30 text-sm font-semibold px-6 py-3 hover:border-bone transition-colors duration-300"
            >
              <Phone size={16} weight="bold" /> {COMPANY.phoneDisplay}
            </a>
          </div>
        </div>
        <div className="md:col-span-3">
          <p className="text-[10px] uppercase tracking-[0.25em] text-bone/40 mb-5">Navigation</p>
          <ul className="space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(" ", "-")}`}
                  className="text-sm text-bone/70 hover:text-signal transition-colors duration-300"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="text-[10px] uppercase tracking-[0.25em] text-bone/40 mb-5">Ydelser</p>
          <ul className="space-y-2.5">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.nr}>
                <Link to="/ydelser" className="text-sm text-bone/70 hover:text-signal transition-colors duration-300">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="text-[10px] uppercase tracking-[0.25em] text-bone/40 mb-5">Juridisk</p>
          <ul className="space-y-2.5">
            <li>
              <Link to="/privatlivspolitik" data-testid="footer-link-privatliv" className="text-sm text-bone/70 hover:text-signal transition-colors duration-300">
                Privatlivspolitik
              </Link>
            </li>
            <li>
              <Link to="/cookiepolitik" data-testid="footer-link-cookies" className="text-sm text-bone/70 hover:text-signal transition-colors duration-300">
                Cookiepolitik
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="pt-8 flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div data-testid="footer-company-info" className="text-sm text-bone/60 space-y-1">
          <p className="font-cabinet font-bold text-bone text-base">{COMPANY.name}</p>
          <p>CVR: {COMPANY.cvr}</p>
          <p>{COMPANY.street}, {COMPANY.city}</p>
          <p>Tlf.: {COMPANY.phone}</p>
        </div>
        <p className="text-[10px] uppercase tracking-[0.25em] text-bone/40">
          Kun erhverv · B2B · Malerentreprenør
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
